import React from "react";
import { Form, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { newCategorySchema } from "../validation/newCategory";
import {
  useTemplateCategoryListQuery,
  useTemplateCategoryNewMutation,
} from "../../../graphql/templateCategory.hooks";
import { StyledInput } from "../../../components/inputs/styledInput";

export const NewTemplateCategory = () => {
  const navigate = useNavigate();
  const [createCategory, { loading: createLoading }] =
    useTemplateCategoryNewMutation();
  const { refetch: categoriesRefetch } = useTemplateCategoryListQuery();

  const initialValues = {
    title: "",
    position: 0,
  };

  const tryCreateNewCategory = async (values: any) => {
    try {
      const { data } = await createCategory({ variables: values });
      if (data.templateCategoryNew.id) {
        categoriesRefetch();
        backToList();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const backToList = () => {
    navigate("/template/category");
  };

  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="mb-4">
          <h1>Create New Template Category</h1>
        </div>
      </div>
      <div className="g-4 py-5 d-flex flex-column justify-content-center align-items-center bg-white rounded">
        <div className="d-flex flex-column flex-md-row justify-content-between col-11 col-md-8">
          <Formik
            initialValues={initialValues}
            validationSchema={newCategorySchema}
            onSubmit={tryCreateNewCategory}
          >
            {({ handleSubmit, touched, errors }) => (
              <Form className="w-100">
                <div className="form-floating mb-3 w-100">
                  <StyledInput
                    name="title"
                    label="Title"
                    error={!!(touched.title && errors.title)}
                  />
                </div>
                <div className="form-floating mb-3 w-100">
                  <StyledInput
                    name="position"
                    type="number"
                    label="Position"
                    className="numberForm"
                    error={!!(touched.position && errors.position)}
                  />
                </div>
                <div className="d-flex flex-column flex-md-row justify-content-between">
                  <button
                    onClick={backToList}
                    className="btn btn-primary text-white col-12 col-md-4 mb-2 mb-md-0"
                  >
                    Back To List
                  </button>
                  <button
                    type="button"
                    disabled={createLoading}
                    onClick={() => handleSubmit()}
                    className="btn btn-primary text-white col-12 col-md-4 py-3 mb-4 mb-md-0"
                  >
                    Save
                    {createLoading && (
                      <Spinner
                        animation="border"
                        role="status"
                        className="ms-2"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    )}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};
